 const Data=[
    {
        label:'Home',
        to:'/'

    },
    {
        label:'About me',
        to:'/about'

    },
    {
        label:'Socials',
        to:'/socials'

    },
    {
        label:'Resume',
        to:'/resume'

    },
    {
        label:'Contact',
        to:'/contact'

    },
    {
        label:'Portfolio',
        to:'/portfolio'

    },
];
export default Data;